import { singleton } from 'tsyringe';
import { EventEmitter } from '../EventEmitter';

interface GcpTokenData {
    accessToken: string;
    expiresAt: number;
}

@singleton()
export class GcpAuthService {
    private accessToken: string | null = null;
    private expiresAt: number | null = null;
    public authStateChanged = new EventEmitter<boolean>(false);

    setTokens(accessToken: string, expiresIn: number = 3600): void {
        this.accessToken = accessToken;
        this.expiresAt = Date.now() + expiresIn * 1000;
        this.authStateChanged.emit(this.isAuthenticated());
    }

    getAccessToken(): string | null {
        if (this.isTokenExpired()) {
            return null;
        }
        return this.accessToken;
    }

    isTokenExpired(): boolean {
        if (!this.expiresAt) return true;
        return Date.now() >= this.expiresAt - 300000;
    }

    isAuthenticated(): boolean {
        return this.accessToken !== null && !this.isTokenExpired();
    }

    clearToken(): void {
        this.accessToken = null;
        this.expiresAt = null;
        this.authStateChanged.emit(false);
    }

    getTokenData(): GcpTokenData | null {
        if (!this.accessToken) return null;

        return {
            accessToken: this.accessToken,
            expiresAt: this.expiresAt || 0,
        };
    }
}
